<template>
  <v-form v-if="!this.submitted" ref="callbackForm" class="callback-form">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="First name"
          outlined
          v-model="form.firstName"
          :rules="[rules.required]"
          color="#009bdc"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="Last name"
          outlined
          v-model="form.lastName"
          :rules="[rules.required]"
          color="#009bdc"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="number-col">
        <v-text-field
          label="Contact number"
          outlined
          v-model="form.contactNumber"
          :rules="[rules.required, rules.australianNumber]"
          color="#009bdc"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="altnumber-col">
        <v-text-field
          label="Alternative contact number"
          outlined
          v-model="form.alternativePhone"
          :rules="[rules.australianNumber]"
          color="#009bdc"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>
          Can the 13 11 20 team member identify as calling from Cancer Council
          Queensland?
        </p>
        <v-radio-group row v-model="form.identify" :rules="[rules.required]">
          <v-radio color="#009bdc" value="Yes" label="Yes" />
          <v-radio color="#009bdc" value="No" label="No" />
        </v-radio-group>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>Can the 13 11 20 team member leave a message?</p>
        <v-radio-group
          row
          v-model="form.leaveMessage"
          :rules="[rules.required]"
        >
          <v-radio color="#009bdc" value="Yes" label="Yes" />
          <v-radio color="#009bdc" value="No" label="No" />
        </v-radio-group>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>
          Can the 13 11 20 team member speak with or leave a message with
          another person?
        </p>
        <v-radio-group
          row
          v-model="form.speakOrLeaveMessageWithAnother"
          :rules="[rules.required]"
        >
          <v-radio color="#009bdc" value="Yes" label="Yes" />
          <v-radio color="#009bdc" value="No" label="No" />
        </v-radio-group>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>
          Cancer Council Queensland 13 11 20 Callbacks are recorded for training
          and supervision purposes
        </p>
        <v-checkbox
          color="#009bdc"
          value="Yes"
          label="I accept"
          v-model="form.acceptRecorded"
          :rules="[rules.required]"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>Cancer Council Queensland 13 11 20 Callbacks display no caller ID</p>
        <v-checkbox
          color="#009bdc"
          value="Yes"
          label="I accept"
          v-model="form.acceptNoCallerID"
          :rules="[rules.required]"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <!-- <p>Select a preferred callback date and time</p> -->
        <!-- <datetime v-model="form.callbackDateAndTime" type="datetime" input-class="datetime-input"></datetime> -->
        <v-text-field
          v-model="form.callbackDateAndTime"
          :rules="[rules.required]"
          label="Select a preferred callback date and time"
          outlined
          type="text"
          id="date-time-picker"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <p>
          By submitting this form you are agreeing to the privacy collection
          statement
          <a
            href="https://cancerqld.org.au/webchat-privacy-collection-statement/"
            target="_blank"
            >here</a
          >.
        </p>
        <v-checkbox
          color="#009bdc"
          value="Yes"
          label="I accept"
          v-model="form.acceptPrivacy"
          :rules="[rules.required]"
        />
      </v-col>
    </v-row>

    <v-col cols="12" sm="12" md="12">
      <button
        :disabled="currentlySubmitting"
        class="btn"
        v-on:click="submitForm($event)"
      >
        {{ currentlySubmitting ? "Submitting. Please wait." : "Submit" }}
      </button>
    </v-col>
  </v-form>
  <div class="thankyou-message" v-else>
    <h3>
      Thank you for submitting the form. We will get in contact with you as soon
      as possible.
    </h3>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import flatpickr from "flatpickr";
import axios from "axios";
// 43309d48-01fd-4512-a05f-9adf9df85562
export default {
  name: "CallbackForm",
  components: { datetime: Datetime },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    submitted: false,
    currentlySubmitting: false,
    form: {
      firstName: null,
      lastName: null,
      email: null,
      contactNumber: null,
      alternativePhone: "",
      identify: null,
      leaveMessage: null,
      speakOrLeaveMessageWithAnother: null,
      acceptRecorded: null,
      acceptNoCallerID: null,
      callbackDateAndTime: null,
      acceptPrivacy: null,
      sourceIdentifier: "createwebchatcallback-webform-h3jfhdna",
    },
    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      australianNumber: (value) => {
        if (!value) {
          return true;
        }
        const pattern = /^(\+61|0[1-9])([0-9]){6,9}$/;
        return (
          pattern.test(value) || "Invalid Australian phone number (+61...)."
        );
      },
    },
  }),
  mounted: function() {
    const fp = flatpickr("#date-time-picker", {
      disable: [
        function(date) {
          // return true to disable
          return date.getDay() === 0 || date.getDay() === 6;
        },
      ],
      altInput: true,
      dateFormat: "Z",
      enableTime: true,
      minDate: "today",
      minTime: "09:00",
      maxTime: "17:00",
    });
  },
  methods: {
    submitForm: async function(event) {
      event.preventDefault();
      const vmf = this.form;
      if (this.$refs.callbackForm.validate()) {
        this.currentlySubmitting = true;
        axios({
          method: "post",
          url:
            "https://prod-01.australiaeast.logic.azure.com:443/workflows/4de7cf13b7814e4085415005274e263e/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=TGGsah2wNyTVNE8zamXOAREl7GHvxpeo565R6BQBR1E",
          data: {
            entry: {
              callbackNumbers: [vmf.contactNumber, vmf.alternativePhone],
              callbackScheduledTime: vmf.callbackDateAndTime,
              callbackUserName: vmf.firstName + " " + vmf.lastName,
              data: {
                source: "Webchat Callback",
                notes: `By ${vmf.firstName} ${vmf.lastName}. Leave message? ${vmf.leaveMessage}. Identify as CCQ? ${vmf.identify}. Speak/leave message with other? ${vmf.speakOrLeaveMessageWithAnother}.`,
                script:
                  vmf.identify.charAt(0) +
                  vmf.leaveMessage.charAt(0) +
                  vmf.speakOrLeaveMessageWithAnother.charAt(0),
              },
            },
            eventType: "webchat-callback",
            sourceIdentifier: vmf.sourceIdentifier,
          },
        })
          .then((res) => {
            this.submitted = true;
          })
          .finally(() => {
            this.currentlySubmitting = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
@use "./_responsive.scss" as *;
.thankyou-message {
  border-bottom: 1px solid grey;
  padding-bottom: 40px;

  h3 {
    color: green;
  }
}
.callback-form {
  // color: #333;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 800px;
  border-bottom: 1px solid grey;
  padding-bottom: 50px;

  .btn {
    color: white;
  }

  .vdatetime-popup__header,
  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #009bdc;
  }

  .vdatetime-year-picker__item--selected,
  .vdatetime-time-picker__item--selected,
  .vdatetime-popup__actions__button {
    color: #009bdc;
  }

  .vdatetime-input.datetime-input {
    border: 1px solid black;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: 20px;
  }

  .row {
    .col-sm-12.col-md-6.col-12 {
      margin-bottom: -20px;
    }
    .v-messages__message {
      color: red !important;
    }

    .v-input.v-text-field--outlined
      .v-input__control
      .v-input__slot
      .v-label--active {
      -webkit-transform: translateY(-28px) translateX(-15px) scale(0.7) !important;
      transform: translateY(-28px) translateX(-15px) scale(0.7) !important;
    }

    .number-col {
      .v-input.v-text-field--outlined
        .v-input__control
        .v-input__slot
        .v-label--active {
        -webkit-transform: translateY(-28px) translateX(-2px) scale(0.7) !important;
        transform: translateY(-28px) translateX(-22px) scale(0.7) !important;
      }
    }

    .altnumber-col {
      .v-input.v-text-field--outlined
        .v-input__control
        .v-input__slot
        .v-label--active {
        -webkit-transform: translateY(-28px) translateX(-30px) scale(0.7) !important;
        transform: translateY(-28px) translateX(-30px) scale(0.7) !important;
      }
    }
  }
}
</style>
